export const HIDDEN_ARTICLE_LABEL = 'd0ff20ba-c0b4-4bdf-bce5-cb5fde5e4294';

export const EXCLUDED_ARTICLES = [
  '0bdfcec6-a05e-4604-be55-cacd7e912259',
  '94a29d5f-32c6-49de-82e9-b83778b27432',
  '3b008278-61c5-46ce-adf8-acf9dfd6ed52',

  // https://app.asana.com/0/1202543453077385/1202685062713731/f
  'b9cf3df0-18ab-4733-b5cc-44167e8adf84',
  'ba6ba27f-3220-4d06-8c2e-9c4fddf89d52',
  '40dc0ecd-bb8f-4a36-b7ff-8e8ec2b3fdf1',
  '12531907-d8fd-4468-89bb-ee8f04754a16',
  '04639f13-0789-4fd0-912c-dbaf414babd6',
  '8dcc90c5-6b95-4aa6-967b-702680673cbe',
  '32a61517-c207-4826-8d6e-88c63578949b',
  '3ae922bb-f2f4-4e7f-94ae-433a64e9e51a',
  '46908539-1eae-4a2d-9cbe-87fea8680a05',
  '58c60d11-989e-4f4f-aa75-d38401f04920',
];

export const EXCLUDED_ARTICLE_LABELS = [
  '188b3b34-07fa-4e37-8bd7-f5703f785015',
  HIDDEN_ARTICLE_LABEL,
  '1b11030f-59c2-477a-8146-1837b149a55e',
  '75ea4355-c7c9-477f-a76e-e2f227e29d39',
  '64725503-8208-41b4-9745-d29be50e510d',
  'f18792d0-9250-4114-a19d-299a3bd0fbdf',
  '5fda49bd-4737-471a-8559-1103e0de3a60',
  'c58b5966-3cfc-4370-8626-05bb7ee3f361',
  '2657251f-4a2d-4b57-955d-9a616ad6379b',
  '5061ddd3-8129-4983-8ebc-deb3517cab6b',
  'd8d1c885-6424-4450-8b3d-a6d3b0e6f7be',
];
